import { render, staticRenderFns } from "./CandidateProfileStep.vue?vue&type=template&id=0c820f48"
import script from "./CandidateProfileStep.vue?vue&type=script&lang=js"
export * from "./CandidateProfileStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports